var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0H0V11H11V0ZM6 2.00001H3V3.00001H4.99999V8.00001H5.99999L6 2.00001ZM3 9.00001V8.00001H8V9.00001H3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0H13V11H24V0ZM22.0001 2.00001H15.0001V3.00001H22.0001V5.00001H23.0001V3.00001H22.0001L22.0001 2.00001ZM15.0001 6.00001H16.0001V8.00001H15.0001V6.00001ZM22.0001 5.00001L16.0001 5.00001L16.0001 6.00001L22.0001 6.00001V5.00001ZM15.0001 8.00001L23.0001 8.00001V9.00001H15.0001V8.00001Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 13H0V24H11V13ZM8.00004 15H2.00004V16H7.99999V18H8.99999V16L7.99999 16L8.00004 15ZM8.00001 19H8.99999V21H7.99999L8.00001 19L4.00001 19V18L7.99999 18L8.00001 19ZM1.99999 21L7.99999 21V22H1.99999V21Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 13H13V24H24V13ZM16.0001 15H15.0001V18H16.0001V19H21V23H22V15H21V18H16.0001L16.0001 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScore);
export default __webpack_public_path__ + "static/media/Score.e2961331327730b0a303b65bdc84f395.svg";
export { ForwardRef as ReactComponent };